import { config } from "../../config";

/**
 * Fetches personal offer data for a given client UUID
 * @param personalUserOfferUUID The client UUID
 * @param emitEventCallback Optional callback to emit events
 * @returns The personal offer data or null if not available
 */
export async function fetchPersonalOffer(
  personalUserOfferUUID: string | null,
  emitEventCallback?: (eventName: string, data: any) => void
): Promise<any> {
  if (!personalUserOfferUUID) {
    // console.debug(
    //   "MonitoringService: Cannot fetch metadata - No personal user offer ID available"
    // );
    return null;
  }

  try {
    if (config.env === "development") {
      console.debug(
        "MonitoringService: Fetching personal user offermetadata for UUID:",
        personalUserOfferUUID
      );
    }
    const response = await fetch(
      `${config.backend.base_url}/personal-offers-api/${personalUserOfferUUID}`
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const offerData = await response.json();
    if (config.env === "development") {
      console.debug("MonitoringService: Fetched Offer Data", {
        offerData: offerData,
      });
    }

    // Emit event if callback provided
    if (emitEventCallback) {
      emitEventCallback("metadata_fetched", {
        success: true,
        metadata: offerData,
      });
    }

    return offerData;
  } catch (error) {
    if (config.env === "development") {
      console.error("MonitoringService: Failed to fetch metadata:", error);
    }

    // Emit error event if callback provided
    if (emitEventCallback) {
      emitEventCallback("metadata_fetched", {
        success: false,
        error: error instanceof Error ? error.message : "Unknown error",
      });
    }

    throw error;
  }
}
